import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import { motion } from 'framer-motion'
import styled from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const DropdownListWrapper = styled.div`
  padding: 0 4px 0 8px;
  height: 350px;
  max-height: 100%;
  overflow-y: scroll;
  ${customizeVerticalScrollbarThumbMixin()}

  @media only screen and (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    width: 100%;
    height: 100%;
    padding: 0;
    padding-bottom: 38px;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const ListWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
`
